import { IActionContext, IRequestContextUser } from '@msdyn365-commerce/core';

export const ensureAuthenticated = (ctx: IActionContext): void => {
    const user = ctx.requestContext.user;
    const { isEditor } = ctx.requestContext.params;

    if ((!user || !user.token) && !isEditor) {
        throw new Error('User is not authenticated');
    }
};

export const runActionAndHandleAuth = async <T>(
    action: () => Promise<T>,
    user: IRequestContextUser,
    onError?: () => void
): Promise<T | undefined> => {
    try {
        return await action();
    } catch (error) {
        if (error instanceof Error && error.message.includes('User is not authenticated')) {
            redirectToSignIn(user);
        } else {
            onError ? onError() : null;
        }
        return;
    }
};

export const redirectToSignIn = (user: IRequestContextUser) => {
    if (user && user.signInUrl) {
        window.location.href = user.signInUrl;
    }
};
